import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { Spirit } from '../styles/spirit-styles'
import { Layout } from '../components/common/layout'
import { SetupBox } from '../components/setup'
import { MetaData, getMetaImageUrls } from '../components/common/meta'

const SetupPage = ({ data, location }) => {
    // Add meta title and description for this page here to overwrite the site meta data as set in the config
    const title = `InspireUI Documents`
    const description = `User Guide to help using the products`
    const imageUrl = getMetaImageUrls()

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
                title={title || data.site.siteMetadata.title}
                description={description || data.site.siteMetadata.description}
                image={imageUrl}
            />
            <Layout mainClass="bg-whitegrey-l2 pb-vw3" bodyClass="bg-white">
                <section className="bg-setup">
                    <div className={`${Spirit.page.xl} tc-ns pt-vw6 pt-vw5-ns pb-vw5 white`}>
                        <h1 className={`${Spirit.sectionHeading} gh-integration-header-shadow`}>Products Guide</h1>
                        <p className={Spirit.sectionSubHeading}>
                            The easiest way to get started is to use <strong>InspireUI products</strong>. 
                        </p>
                    </div>
                </section>

                <div className={`${Spirit.page.xl} mt-vw3`}>
                    <section className="grid-12 gutter-row-20 gutter-20-ns gutter-36-l">
                        <SetupBox to="/fluxstore" title="Fluxstore Pro" image="fluxstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                FluxStore Pro - Universal mobile commerce <strong>Flutter</strong> app for Magento, WooCommerce and Opencart
                            </p>
                        </SetupBox>
                        <SetupBox to="/fluxnews" title="FluxNews" image="fluxnews.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                FluxNews - Flutter App for Wordpress
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore" title="MStore Pro" image="mstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The Complete React Native template for <strong>mobile commerce</strong> app by React Native
                            </p>
                        </SetupBox>
                        <SetupBox to="/fluxstore/woocommerce-setup/" title="Fluxstore WooCommerce" image="fluxstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Universal mobile commerce <strong>Flutter</strong> app for WooCommerce
                            </p>
                        </SetupBox>
                        <SetupBox to="/fluxstore/multi-vendor//" title="Fluxstore Multi Vendor" image="fluxstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Multi Vendor app <strong>Flutter</strong> app for WooCommerce
                            </p>
                        </SetupBox>
                        <SetupBox to="/fluxstore/listing-directory/" title="Fluxstore Listing" image="fluxstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The Best Of Listing Directory Flutter App
                            </p>
                        </SetupBox>
                        <SetupBox to="/fluxstore/fluxstore-shopify/" title="Fluxstore Shopify" image="fluxstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Universal mobile commerce Flutter app For Shopify 
                            </p>
                        </SetupBox>
                        <SetupBox to="/beonews" title="BeoNews Pro" image="beonews.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                React Native mobile app for Wordpress for Multi-purpose
                            </p>
                        </SetupBox>

                        <SetupBox to="/listapp" title="ListApp" image="listapp.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                            Listing Directory mobile app by React Native support MyLising, Listify & Listable
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore-magento" title="Mstore Magento" image="mstore-magento.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The complete react native app for Magento 2
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore-opencart" title="Mstore Opencart" image="mstore-opencart.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The complete react native app for Opencart
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore-shopify" title="Mstore Shopify" image="mstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The complete react native app for Shopify
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore-mv" title="Mstore Multi Vendor" image="mstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Complete React Native template for WooCommerce, support with Dokan, WC Vendor & WCFM Marketplace
                            </p>
                        </SetupBox>
                        <SetupBox to="/evastore" title="EvaStore" image="evastore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                            Shopify mobile store by React Native and GraphQL
                            </p>
                        </SetupBox>
                        <SetupBox to="/mstore-shopify" title="Mstore Shopify" image="mstore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Mstore Shopify mobile store by React Native and Rest API
                            </p>
                        </SetupBox>
                        <SetupBox to="/cestore" title="CeStore" image="cestore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                            ReactJS web app & React Native mobile app for e-commerce
                            </p>
                        </SetupBox>
                        <SetupBox to="/buzzapp" title="Buzzapp" image="buzzapp.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                            Viral Magazine WordPress app by React Native (CeNews)
                            </p>
                        </SetupBox>
                        <SetupBox to="/cestore-web" title="CeStore Web" image="cestore.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                            Ecommerce Progressive Web Apps Template by ReactJS & MongoDB
                            </p>
                        </SetupBox>
                        <SetupBox to="/listpro" title="ListPro" image="listpro.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                Listing Directory React Native template
                            </p>
                        </SetupBox>
                        <SetupBox to="/reactxs" title="ReactXS" image="reactxs.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                 UIKit for Material Design 2.0 by React Native
                            </p>
                        </SetupBox>
                        <SetupBox to="/beonboard" title="BeOnboard" image="beonboard.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The complete onboarding template for React Native app
                            </p>
                        </SetupBox>
                        <SetupBox to="/reactpage" title="ReactPage" image="reactpage.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The Bootstrap Starter Kit for ReactJS and Wordpress
                            </p>
                        </SetupBox>
                        <SetupBox to="/beostore" title="BeoStore" image="beoui.png" headingClass="mt2">
                            <p className={`${Spirit.small} mw70`}>
                                The complete Mobile UI template for React Native
                            </p>
                        </SetupBox>
                        
                    </section>
                </div>
            </Layout>
        </>
    )
}

SetupPage.propTypes = {
    data: PropTypes.shape({
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                siteUrl: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
}

export default SetupPage

export const pageQuery = graphql`
    query {
        site {
            ...SiteMetaFields
        }
    }
`
